import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import moment from 'moment';
//import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import GraphAnnotation from '../../../containers/graphAnnotation.js';
import GraphPlotline from '../../../containers/graphPlotline.js';
import AnnotationsFactory from 'highcharts/modules/annotations';
import JSZip from 'jszip';
import { downloaduploadedDocumentsOnAPICall } from '../../../constants/ApiConstants';
import { getSVG, svgToPng } from '../../../../../actions/utilAction';
import RaisedButton from 'material-ui/RaisedButton';
import { getAverageLine, getTrendData, getTrendLine } from '../../../../../chartUtils/utlis.js';
AnnotationsFactory(Highcharts);
Exporting(Highcharts);
ExportingData(Highcharts);


class BehaviourGraph extends Component {

    constructor(props) {
        super(props);        
        this.state = {            
            sliderMaxValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            sliderValue: props.yAxisMaxValue ? props.yAxisMaxValue : 100,
            AnnotationLabel : [],
            BaselineLabel : [],
            xAxisDateOption: [],
            chartArray: [],            
            behaviorNameArray: [],         
          };
        //this.onSliderChange = this.onSliderChange.bind(this);
        this.setAnnotationState = this.setAnnotationState.bind(this);
        this.setBaselineState = this.setBaselineState.bind(this);
      }

    componentDidMount = () => {
        this.highchartsHandler();
    }

    // This method will be sent to the child component
    setAnnotationState(AnnotationState) {
        let annotationLabel = []; 
        annotationLabel.push(AnnotationState);       
        this.setState({
            AnnotationLabel: annotationLabel
        },()=>this.highchartsHandler());
    }

    // This method will be sent to the child component
    setBaselineState(BaselineState) {          
        this.setState({
            BaselineLabel: BaselineState
        },()=> this.highchartsHandler());
    }

    highchartsHandler = () => {
        let finalData = [];
        let behaviorsReductionId = [];
        let xAxisDateBeforeSorting = [];
        let graphTitle = [];
        let xAxisDate = [];
        // let FromDate = moment(this.props.FromDate, 'YYYY-MM-DD');
        // let ToDate = moment(this.props.ToDate, 'YYYY-MM-DD');
        // let diff = ToDate.diff(FromDate, 'days', false);
        // diff = diff + 1;
        let xAxisLabel = this.props.xAxisName === undefined ? 'Data' : this.props.xAxisName;
        let yAxisLabel = this.props.yAxisName === undefined ? 'Date' : this.props.yAxisName;
        let disableYaxislabel = this.props.disableYaxislabel;
        let disableXaxislabel = this.props.disableXaxislabel;
        let disableLegend = this.props.disableLegend;
        let gridlinesWidth = this.props.hideGridlines ? 0 : 1;
        let displayAverage = this.props.displayAverage;
        let seriesSum = 0, seriesCount = 0, avgPlotLine = {};
        let plotLines = [];
        let xDates = [];
        let behaviorsReductionIds = []
        let behaviorNames = [];
        let xDatesObj = {};
        //let selectedProgram = this.props.selectedProgram;

        let yAxispaddings = [];


        function getMaxValue(arr){
            if(arr.length){
                let value  = Math.max(...arr);
                return value;    
            }
        }

        function twentyPercentOf(value) {
            return (value * 20) / 100;
        }

        if (this.props.dataAnalytics.DCPatientBehaviourGraphData !== null && this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0) {
            const graphData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs;
            graphData.forEach(obj=>{
                if(!behaviorsReductionIds.includes(obj.behaviorsReductionId)){
                    behaviorsReductionIds.push(obj.behaviorsReductionId);
                    behaviorNames.push(obj.behaviorName);  
                }
            })
            
            
            behaviorsReductionIds.map((behaviorsReductionId, index) => {
                let dataObj = {}
                let behaviorData = [];
                // let behaviordataForDate = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs;
                let filteredGraphDataByTargetId = graphData.filter((op) => op.behaviorsReductionId === behaviorsReductionId)
                .sort((a, b) => new Date(a.dos) - new Date(b.dos));;

                xAxisDateBeforeSorting = [];

                filteredGraphDataByTargetId.forEach((data)=>{
                    xAxisDateBeforeSorting.push(moment(data.dos).format('MM/DD/YYYY'));
                })
                
                // for (let i = 0; i < behaviordataForDate.length; i++) {
                //     if(xAxisDateBeforeSorting.indexOf(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY')) === -1)
                //     {
                //         xAxisDateBeforeSorting.push(moment(behaviordataForDate[i].dos).format('MM/DD/YYYY'));
                //     }
                // }
               
                xDates.push(xAxisDateBeforeSorting);
                xDatesObj[behaviorsReductionId]=xAxisDateBeforeSorting
               
                if(this.props.displaySavedPhaseChangeLines)
                { 
                    let phaseChangeLineData = filteredGraphDataByTargetId;
                    for (let k = 0; k < phaseChangeLineData.length; k++) {                          
                        let lineIndex = xAxisDateBeforeSorting.indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY')); 
                        if(lineIndex === -1)
                        {
                            xAxisDateBeforeSorting.push(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY'));
                        }
                    }
                }

                // xAxisDateBeforeSorting.sort((date1, date2) => {
                //     date1 = date1.split('/').reverse().join('');
                //     date2 = date2.split('/').reverse().join('');
                //     return date1.localeCompare(date2);
                // });
             
                xAxisDateBeforeSorting.sort((dateA, dateB) => new Date(dateA) - new Date(dateB));
               
                xAxisDate = [];
                 
                for(let j = 0; j < xAxisDateBeforeSorting.length; j++)
                {  
                    xAxisDate[j] = moment(xAxisDateBeforeSorting[j]).format('MM/DD/YYYY');
                }

                if(behaviorsReductionId){   
                    let behaviorName = '';
                    let goaldata = filteredGraphDataByTargetId;
                    behaviorData = [];
                    for (let i = 0; i < goaldata.length; i++) {
                        dataObj['name'] = goaldata[i].behaviorName;
                        dataObj['behaviorsReductionId'] = goaldata[i].behaviorsReductionId;
                        behaviorName = goaldata[i].behaviorName;
                        // behaviorsReductionId.push(goaldata[i].behaviorsReductionId);
                        if(xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY')) > -1)
                        {
                            let index = xAxisDate.indexOf(moment(goaldata[i].dos).format('MM/DD/YYYY'));
                            behaviorData[index] = parseFloat(goaldata[i].behaviorData);
                            // targetData.push(goaldata[i].targetData);
                            // seriesSum += parseFloat(goaldata[i].targetData);
                            // seriesCount += 1;
                            const filteredTargetData = behaviorData.filter(value => value !== null);
                            seriesSum = filteredTargetData;
                        }
                    }

                    for(let j = 0; j < xAxisDate.length; j++)
                    {
                        //if(!targetData[j])
                        if(behaviorData[j] === undefined)
                        {
                            behaviorData[j] = null;
                        }
                    }

                    let length = behaviorData.length;
                    let totalSeriesSum = behaviorData.reduce((sum, value) => sum + value, 0);
                    let maxValue = getMaxValue(behaviorData);
                    if(maxValue < 100){
                        let plus20PercOnMaxValue = twentyPercentOf(maxValue);
                        maxValue = maxValue + plus20PercOnMaxValue;
                    }
                    let avgData = {}
                    if (displayAverage && length > 0 && length > 0 && !this.props.showTrendChart) {
                        var seriesAvg = (totalSeriesSum / length).toFixed(2);
                        let avgD = {};
                        let sAvg;
                        if(behaviorData){    
                            let length = behaviorData.length;
                            let newArray = new Array(length);
                            sAvg = parseFloat(seriesAvg);
                            let filledArray = newArray.fill(null);
                            filledArray[0] = sAvg;
                            filledArray[newArray.length-1] = sAvg;
                            avgD = filledArray;
                            }
                        avgData = {
                            type: 'line',
                            name: 'Average Line',
                            data: avgD,
                            width: 2,
                            marker:{
                                enabled:false
                            },
                            color: 'transparent',
                            dashStyle: 'shortDash',
                        }

                        plotLines.push({
                            color:"#000000",
                            width: 2,
                            value: [sAvg],
                            zIndex: 4,
                            dashStyle: 'Dash',
                            label: {
                              text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                              align: 'right',
                              x: 0,
                              y: -10
                          }
                        });

                        // avgPlotLine = {
                        //                         value: seriesAvg,
                        //                         color: '#000000',
                        //                         width: 2,
                        //                         dashStyle: 'shortdash',
                        //                         id: 'avgPlotLine1',
                        //                         label: {
                        //                             text: seriesAvg
                        //                         }
                        //                     }

                        // plotLines.push({
                        //     color: 'transparent',
                        //     width: 0,
                        //     value: [sAvg],
                        //     zIndex: 4,
                        //     dashStyle: 'Dash',
                        //     label: {
                        //       text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                        //       align: 'right',
                        //       x: 0,
                        //       y: -10
                        //   }
                        // });
                       yAxispaddings.push(maxValue);
                        dataObj['data'] = behaviorData;
                        finalData.push([avgData,dataObj]);
                        graphTitle.push(behaviorName);
                      }else{
                    yAxispaddings.push(maxValue);
                    dataObj['data'] = behaviorData;
                    finalData.push([dataObj]);
                    graphTitle.push(behaviorName);
                    }
                }
            })


            if(this.props.phaseChangeLineDataFlag && !this.props.displaySavedPhaseChangeLines)
            {
                this.setState({ BaselineLabel: [] });
            }
    
            if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
                let phaseChangeLineFinalData = phaseChangeLineData.filter(obj=>obj)  
                for (let k = 0; k < phaseChangeLineFinalData.length; k++) {
                    let reducId = phaseChangeLineData[k].behaviorsReductionId
                    let lineIndex =reducId !== 0 && xDatesObj[reducId]? xDatesObj[reducId].indexOf(moment(phaseChangeLineData[k].lineDate).format('MM/DD/YYYY')): -1;
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data && data.date === phaseChangeLineData[k].lineDate)
                            return true;
                    });
                    // if (indexValue !== -1) 
                    //     this.state.BaselineLabel.splice(indexValue, 1);
                    
                    if(indexValue === -1 && Number(lineIndex) >= 0 && phaseChangeLineData[k].lineLabel)
                    {  
                        let label = {
                                        id: 'plotLine_' + Math.random(),
                                        value: Number(lineIndex),
                                        color: '#000000',
                                        width: 2,
                                        date:phaseChangeLineData[k].lineDate,
                                        key: phaseChangeLineData[k].lineLabel,
                                        dashStyle: phaseChangeLineData[k].lineTypeName,
                                        behaviorsReductionId: phaseChangeLineData[k].behaviorsReductionId ,             
                                        label: {
                                            text: phaseChangeLineData[k].lineLabel
                                        },
                                        events: {
                                            dblclick: function(e) {
                                                this.axis.removePlotLine(this.id)
                                            }
                                        }
                                    };
                        
                        BaselineState.push(label);                                    
                    }
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);                  
            }
            else if(this.props.phaseChangeLineDataFlag && xAxisDate.length > 0 && !this.props.displaySavedPhaseChangeLines)
            {
                let phaseChangeLineData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionPhaseChangeLineGraphs;
                let BaselineState = this.state.BaselineLabel;  
          
                for (let k = 0; k < phaseChangeLineData.length; k++) {                         
                    
                    var indexValue = this.state.BaselineLabel.findIndex(function(data, index) {
                        if(data.key === phaseChangeLineData[k].lineLabel)
                            return true;
                    });
                    if (indexValue !== -1) 
                        this.state.BaselineLabel.splice(indexValue, 1);
                }
                
                this.props.setPhaselineState(false);            
                this.setBaselineState(BaselineState);  
            }
    
        }
         
        if(xAxisDate.length  && this.state.xAxisDateOption.length != xAxisDate.length)
            {
                let xAxisDate1 = [];
    
                xAxisDate1 = xAxisDate.map((d,i)=>{
                    return {
                        'id':i,
                        'value':d.toString()
                    }
                })
                
                this.setState({xAxisDateOption: xAxisDate1}
                    ,()=>{ this.setState({})}
                    );           
            }
      
        graphTitle.reverse();        
        finalData.reverse();
        xDates.reverse();
        yAxispaddings.reverse();
        plotLines.reverse();

        function formatSecondsToDate(seconds) {
            const date = new Date(new Date(seconds).toUTCString());
            let day = date.getUTCDate();
            let month = date.getUTCMonth() + 1;
            let year = date.getUTCFullYear();

            let formattedMonth = month < 10 ? `0${month}` : `${month}`;
            let formattedDay = day < 10 ? `0${day}` : `${day}`;

            let formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
            return formattedDate;
          }

          function modifyMulArrToSingleWithYAxis(arr,length,type){
              let updatedArr = [];
              if(type=="trendline" && arr.length){
                let emptyArry = new Array(length).fill(null);
                emptyArry[0] = parseFloat(arr[0][1].toFixed(2));
                emptyArry[length-1] = parseFloat(arr[1][1].toFixed(2));
                updatedArr = emptyArry;
              }else if(arr.length){
                for(let i=0;i<length;i++){
                  if(arr[i] && arr[i][1] != null && arr[i][1] != undefined){
                    updatedArr.push(parseFloat(arr[i][1].toFixed(2)))
                  }else {
                    updatedArr.push(null);
                  }
                }
              }
              return updatedArr;
        }


        let chartData = [];
        if(this.props.dataAnalytics != null && this.props.dataAnalytics.DCPatientBehaviourGraphData != null && this.props.dataAnalytics.DCPatientBehaviourGraphData.data && this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs && this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0) {
            
            let graphHoursData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.map(d=>{
                return {...d,behaviorData:parseFloat(d["behaviorData"])};
            });
            

            if(this.props.showTrendChart){
              chartData = finalData.map((c,i)=>{
                let gfData = graphHoursData.filter(d=>d.behaviorsReductionId === c[0].behaviorsReductionId);
                let trndSData = getTrendData(gfData,"behaviorData","dos")
                let trndSLine = getTrendLine(trndSData);
                let trndData = modifyMulArrToSingleWithYAxis(trndSData,trndSData.length)
                let trndLine = modifyMulArrToSingleWithYAxis(trndSLine,trndSData.length,"trendline")
                xAxisDate = trndSData.map(([a,b])=>formatSecondsToDate(a));
                let newC = {...c,data:trndData};

                let singleAvgLength = trndData.length;
                let totalAvgTrndData = trndData.reduce((acc, curr) => {
                    return acc + curr ;
                },0)

                let avgData = {}
                let sAvg;
                
                if (displayAverage && singleAvgLength > 0 && singleAvgLength > 0 && this.props.showTrendChart){
                    var seriesAvg = (totalAvgTrndData / singleAvgLength).toFixed(2);
                    let avgD = {};
                    if(trndData){    
                        let length = trndData.length;
                        let newArray = new Array(length);
                        sAvg = parseFloat(seriesAvg);
                        let filledArray = newArray.fill(null);
                        filledArray[0] = sAvg;
                        filledArray[newArray.length-1] = sAvg;
                        avgD = filledArray;
                    }
                    avgData = {
                            type: 'line',
                            name: 'Average Line',
                            data: avgD,
                            width: 2,
                            marker:{
                                enabled:false
                            },
                            color: 'transparent',
                            dashStyle: 'shortDash',
                        }
                    plotLines.push({
                        color:"#000000",
                        width: 2,
                        value: [sAvg],
                        zIndex: 4,
                        dashStyle: 'Dash',
                        label: {
                          text: sAvg && sAvg != 0 ? `${sAvg} Avg`:'',
                          align: 'right',
                          x: 0,
                          y: -10
                      }
                    });
                }
                    
                return [
                    newC,
                    avgData,
                    {

                        type: 'line',
                        name: 'Trend Line',
                        data: trndLine,
                        value: 454,
                        width: 2,
                        marker: {
                            enabled: false
                        },
                        dashStyle: 'longdash',
                        color:"#000000"
                      }
                ]
              })
            //   console.log("chartData",chartData)
            }
          }

        Highcharts.setOptions({
            colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000']
        });
        
        let behaviorsReductionId1 = [];
        let chartArray = [];
        let arrIndex = 0;        
        // let behaviorNameArray = [];
        let phaseChangeLineData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionPhaseChangeLineGraphs;
        let phaseChangeLineDataId = phaseChangeLineData.map(ele=>ele.behaviorsReductionId)

       

        finalData.length && 
        finalData.map((obj, index) => {  
                let chart = null;
                behaviorsReductionId1.push(obj.behaviorsReductionId);
                // behaviorNameArray.push(obj.behaviorName);                
                Highcharts.chart(`analyticsDataDiv[${index}]`, {

                    title: {
                        text: `<b>${graphTitle[arrIndex]}</b>`,
                    },
                    
                    // chart: {
                    //     type: 'line',
                    //     zoomType: 'y'
                    // },            
                    annotations: this.state.AnnotationLabel,
                    yAxis: {
                        gridLineWidth: gridlinesWidth,
                        minorGridLineWidth: gridlinesWidth, 
                        title: {
                        text: `<b>${xAxisLabel}</b>`
                        },
                        labels: {
                            enabled: disableYaxislabel
                        },
                        // min: 0,
                        // max: this.state.sliderValue,
                        plotLines: plotLines[index] && [plotLines[index]],
                        max: yAxispaddings[index]
                    },
                    legend: {
                        align: 'left',
                        verticalAlign: 'bottom',
                        useHTML: true,
                        enabled: disableLegend,
                        reversed: false,
                        //itemWidth:260,
                        itemStyle: {
                        'font-size': '14px',               
                        'letter-spacing': '0',
                        'line-height': '17px',
                        'text-align': 'center',
                                "textOverflow": "ellipsis"
                        },            
                    },
                    // legend: {
                    //     layout: 'vertical',
                    //     align: 'right',
                    //     verticalAlign: 'middle',
                    //     enabled: disableLegend
                    // },
                   
                    xAxis: {
                        type: this.props.showTrendChart && 'datetime',
                        title: {
                            text: `<b>${yAxisLabel}</b>`,
                        },
                        tickLength: 0,
                        categories: xDates[index],
                        labels: {
                            // rotation: this.props.showTrendChart && -45,
                            // formatter: this.props.showTrendChart && function() {
                            //     return Highcharts.dateFormat('%m/%d/%Y', this.value);
                            // },
                            enabled: disableXaxislabel
                        },
                        plotLines: this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined ? this.state.BaselineLabel : [],
                    }, 

                    credits: {
                        enabled: false
                    },

                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            connectNulls: true,
                            //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                            fillOpacity: 0.6,
                            label: {
                                connectorAllowed: false
                            },
                            dataLabels: {
                                enabled: false
                            },
                            events: {
                                legendItemClick: function () {
                                    return false
                                }
                            },
                            marker: {
                                enabled: true        
                            }
                        }
                    },

                    series: this.props.showTrendChart ?
                          chartData[arrIndex] :
                          finalData[arrIndex],
                   
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom',
                                    enabled: disableLegend
                                }
                            }
                        }]
                    },

                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            x: -100
                        }
                    },

                    lang: {
                        contextButtonTitle: 'Click to open'
                    },

                    exporting: {
                        enabled: false
                    }
                    // exporting: {
                    //     buttons: {
                    //         contextButton: {
                    //             menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    //         }
                    //     },
                    //     chartOptions: {
                    //         colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                    //     }
                    // }
                });

                chart = Highcharts.chart(`analyticsDataDiv[${index}]`, {

                    title: {
                        text: graphTitle[arrIndex],
                    },
                    
                    // chart: {
                    //     type: 'line',
                    //     zoomType: 'y'
                    // },            
                    annotations: this.state.AnnotationLabel,
                    yAxis: {
                        gridLineWidth: gridlinesWidth,
                        minorGridLineWidth: gridlinesWidth, 
                        title: {
                        text: `<b>${xAxisLabel}</b>`
                        },
                        labels: {
                            enabled: disableYaxislabel
                        },
                        // min: 0,
                        // max: this.state.sliderValue,
                        plotLines: plotLines[index] && [plotLines[index]],
                        // max: maxValue(finalData) + 10
                        max: yAxispaddings[index]
                    },
                    legend: {
                        align: 'left',
                        verticalAlign: 'bottom',
                        useHTML: true,
                        enabled: disableLegend,
                        reversed: false,
                        //itemWidth:260,
                        itemStyle: {
                        'font-size': '14px',               
                        'letter-spacing': '0',
                        'line-height': '17px',
                        'text-align': 'center',
                                "textOverflow": "ellipsis"
                        },            
                    },
                    // legend: {
                    //     layout: 'vertical',
                    //     align: 'right',
                    //     verticalAlign: 'middle',
                    //     enabled: disableLegend
                    // },

                    xAxis: {
                        type: this.props.showTrendChart && 'datetime',
                        title: {
                            text: `<b>${yAxisLabel}</b>`,
                        },
                        tickLength: 0,
                        categories:  xDates[index],
                        labels: {
                            // rotation: this.props.showTrendChart && -45,
                            // formatter: this.props.showTrendChart && function() {
                            //     return Highcharts.dateFormat('%m/%d/%Y', this.value);
                            // },
                            enabled: disableXaxislabel
                        },
                        plotLines: this.state.BaselineLabel && this.state.BaselineLabel != undefined &&  this.state.BaselineLabel[0] &&  this.state.BaselineLabel[0] != undefined && phaseChangeLineDataId.includes(obj[0].behaviorsReductionId) ? this.state.BaselineLabel.filter(ele=>ele.behaviorsReductionId===obj[0].behaviorsReductionId): [],
                    },

                    credits: {
                        enabled: false
                    },

                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            connectNulls: true,
                            //connectNulls: this.state.BaselineLabel.length > 0 ? false : true,
                            fillOpacity: 0.6,
                            label: {
                                connectorAllowed: false
                            },
                            dataLabels: {
                                enabled: false
                            },
                            events: {
                                legendItemClick: function () {
                                    return false
                                }
                            },
                            marker: {
                                enabled: true        
                            }
                        }
                    },

                    series:  this.props.showTrendChart ?  chartData[arrIndex] :finalData[arrIndex],

                   
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom',
                                    enabled: disableLegend
                                }
                            }
                        }]
                    },

                    navigation: {
                        buttonOptions: {
                            verticalAlign: 'top',
                            x: -100
                        }
                    },

                    lang: {
                        contextButtonTitle: 'Click to open'
                    },

                    exporting: {
                        enabled: false
                    }
                    // exporting: {
                    //     buttons: {
                    //         contextButton: {
                    //             menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                    //         }
                    //     },
                    //     chartOptions: {
                    //         colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
                    //     }
                    // }
                });
                arrIndex = arrIndex + 1;
                chartArray.push(chart);
            // }             

            // this.setState({ chartArray: chartArray});            
        });    
        this.setState({ chartArray: chartArray}); 
        this.setState({ behaviorNameArray : behaviorNames.reverse()});
    }

    BatchExportToPDF = () => {  
        
        var zip = new JSZip();
        let svgArray = [];
        //var svg1 = getSVG([chart1, chart2]);
        this.state.chartArray.forEach((value, index) => {               
            var svg2 = getSVG([this.state.chartArray[index]]);
            //svgArray.push(svg1);
            svgArray.push(svg2);
          });
        
        let promises = [];
        for (let i = 0; i < svgArray.length; i++) {
          promises.push(svgToPng(svgArray[i], 0, 0));
        }
        Promise.all(promises).then((pngArr) => {
          if (pngArr.length) {
            //let count = 1;
            let i = 0;
            pngArr.forEach((data) => {
              var src = data.substr(data.indexOf(',') + 1);
             // zip.file('chart' + count + '.png', src, {
              zip.file(this.state.behaviorNameArray[i].replace(' ', '_') + '_' + i.toString() + '.png', src, {                
                base64: true
              });
              //count++;
              i++;
            });
            zip.generateAsync({
              type: "blob"
            }).then(function(blob) { // 1) generate the zip file
             // saveAs(blob, "charts.zip"); // 2) trigger the download
              downloaduploadedDocumentsOnAPICall(blob, "BehaviorReductionGraphs.zip");
            }, function(err) {
              console.log("error :", err);
            });
          }
        });
      };

    

    renderData() {

        let behaviorsReductionIds = [];
        if (this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0) {
            const graphData = this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs;
            graphData.forEach(obj=>{
                if(!behaviorsReductionIds.includes(obj.behaviorsReductionId)){
                    behaviorsReductionIds.push(obj.behaviorsReductionId);
                }
            })
        }
        return behaviorsReductionIds && behaviorsReductionIds.map((behaviorsReductionId,index)=>{
            return (
                <div id={`analyticsDataDiv[${index}]`} style={{ height: '500px' }} />
            );
        });
        // return this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.length > 0 && 
        // this.props.dataAnalytics.DCPatientBehaviourGraphData.data.patientBehaviorsReductionGraphs.map((obj, index) => {            
        //     if(behaviorsReductionId1.indexOf(obj.behaviorsReductionId) === -1)
        //     {
        //         behaviorsReductionId1.push(obj.behaviorsReductionId);
        //         return (
        //             <div id={`analyticsDataDiv[${index}]`} style={{ height: '500px' }} />           
        //         );
        //     }
        // });
      };

    // onSliderChange = (value) => {     
    //     this.setState({
    //         sliderValue: value
    //     },()=> this.highchartsHandler());
    // }

    render() {
        //let { sliderValue } = this.state
        return (
            <div className='row'>
                {/* <div className='col-sm-auto'>
                    <Slider 
                        min={0}
                        max={this.state.sliderMaxValue}                           
                        value={sliderValue}
                        orientation="vertical"
                        onChange={(e)=>this.onSliderChange(e)}
                        tooltip={false}
                    />
                </div> */}
                <div className='col-sm-11'>
                    {this.state.xAxisDateOption.length > 0 ? 
                    <div className='row'>
                        <div className='col-sm-3'><GraphAnnotation setAnnotationState={this.setAnnotationState} xAxisDateOption={this.state.xAxisDateOption}/></div>
                        <div className='col-sm-3'><GraphPlotline setBaselineState={this.setBaselineState} xAxisDateOption={this.state.xAxisDateOption} BaselineLabel = {this.state.BaselineLabel}/></div>
                        <div className='col-sm-3'>
                            {/* <RaisedButton className="grey_btn ml_15" onTouchTap={(e) => this.BatchExportToPDF(e)} >Batch Export To PDF</RaisedButton> */}                                
                            <div className='row'>
                                <div className="col-12 col-sm-12 col-md-12 btn_lft reset-btn claims_filter mt-20">
                                    <RaisedButton className="grey_btn" type="Submit" primary={true}  onTouchTap={(e) => this.BatchExportToPDF(e)} >Download all Graphs</RaisedButton>                                      
                                </div>
                            </div>
                        </div>   
                        <div className='col-sm-3'></div>
                    </div>
                     : null}
                     {this.renderData()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    // console.log('state.dcSkillAcquisitionBatchGraph ---', state.dcSkillAcquisitionBatchGraph);
    return {
        dataAnalytics: state.dcSkillAcquisitionBatchGraph
    };
}

export default connect(mapStateToProps, null)(BehaviourGraph)



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/BehaviourGraph/BehaviourGraph.js